import { VendorDTO } from "../types/VendorDTO";
import { apiFetch } from "./apiFetch";
import { getApiErrorMessage } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function getVendors(companyId: string): Promise<VendorDTO[]> {
  const res = await apiFetch(
    `${API_URL}/vendors?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać listy dostawców.")
    );
  }

  const data = await res.json();
  return data.items;
}

